import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { riversideConfig } from "./data";

export default function RiversidePage() {
  return <CityPageTemplate config={riversideConfig} />;
}